// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1kBje","up":"header_up__tbFNk"};